export default "__VITE_ASSET__BcBqNQ2S__"